export const Edges = [
  { value: "none", text: "None" },
  { value: "straight", text: "Straight All" },
  { value: "rough", text: "Rough Edge" },
  { value: "roughTop", text: "Rough Top" },
  { value: "roughAll", text: "Rough All" }
];
export const Dividers = [
  { value: "no line", text: "No Line" },
  { value: "dotted", text: "Dotted" },
  { value: "solid", text: "Solid" }
];
export const HorizontalMeasurements = [
  { value: "none", text: "None" }, // no horizontal measurement logged for the steps
  { value: "logTop", text: "Log Top" }, // log horizontal measurement for the top step on the top step
  { value: "logBottom", text: "Log Bottom" }, // log horizontal measurement for the bottom step on the bottom step
  { value: "top", text: "Top" }, // log horizontal measurement for the top step in the top horizontal measurements
  // log horizontal measurement for the bottom step in the top horizontal measurements
  { value: "bottom", text: "Bottom" },
  // log horizontal measurement for both top and bottom step in the top horizontal measurements
  { value: "both", text: "Both" },
  // log the max (top step + bottom step) horizontal measurement in the top horizontal measurements
  { value: "combined", text: "Max" }
];
export const VerticalMeasurements = [
  { value: "show", text: "Show" },
  { value: "defer", text: "Defer" },
  { value: "none", text: "None" }
];
export type Side = "left" | "right";
export const RootsObserved = ["None", "No Roots", "Roots", "Hair and Fibrous"];
export const LayerMaterials = [
  { value: "brick", text: "Brick" },
  { value: "bituminous", text: "Bituminous" },
  { value: "concrete", text: "Concrete" },
  { value: "sand", text: "Sand" },
  { value: "soil", text: "Made ground" },
  { value: "slab", text: "Slab" },
  { value: "clay", text: "Clay" },
  { value: "grass", text: "Grass" },
  { value: "wood", text: "Wood" },
  { value: "other", text: "Other" },
  { value: "903", text: "Bentonite" },
  { value: "906", text: "Concrete" },
  { value: "101", text: "TOPSOIL" },
  { value: "102", text: "MADE GROUND" },
  { value: "201", text: "CLAY" },
  { value: "202", text: "CLAY with silt" },
  { value: "203", text: "Sandy CLAY" },
  { value: "204", text: "Gravelly CLAY" },
  { value: "205", text: "CLAY with Cobbles" },
  { value: "206", text: "CLAY with boulders" },
  { value: "207", text: "Silty sandy CLAY" },
  { value: "208", text: "Silty gravelly CLAY" },
  { value: "209", text: "Silty cobbles CLAY" },
  { value: "210", text: "Silty CLAY with boulders" },
  { value: "211", text: "Silty sandy gravelly CLAY" },
  { value: "212", text: "Silty sandy CLAY with cobbles" },
  { value: "213", text: "Silty sandy CLAY with boulders" },
  { value: "214", text: "Silty sandy gravelly CLAY with cobbles" },
  { value: "215", text: "Silty sandy gravelly CLAY with boulders" },
  { value: "216", text: "Silty sandy CLAY with gravel, cobbles and boulders" },
  { value: "217", text: "Silty sandy CLAY with peat" },
  { value: "218", text: "Silty sandy gravelly CLAY with peat" },
  { value: "219", text: "Silty CLAY with peat" },
  { value: "220", text: "Sandy gravelly CLAY" },
  { value: "221", text: "SILT/CLAY" },
  { value: "222", text: "Sandy CLAY with cobbles" },
  { value: "223", text: "Sandy CLAY with boulders" },
  { value: "224", text: "Sandy gravelly CLAY with cobbles" },
  { value: "225", text: "Sandy CLAY with gravel and boulders" },
  { value: "226", text: "Sandy gravelly cobbles boulders CLAY" },
  { value: "227", text: "Sandy organic CLAY" },
  { value: "228", text: "Sandy gravelly organic CLAY" },
  { value: "229", text: "Organic CLAY" },
  { value: "230", text: "Sandy SILT/CLAY with gravel and cobbles" },
  { value: "231", text: "Sandy SILT/CLAY with gravel and boulders" },
  { value: "232", text: "Sandy SILT/CLAY with gravel, cobbles and boulders" },
  { value: "233", text: "Sandy SILT/CLAY with peat" },
  { value: "234", text: "Sandy SILT/CLAY with gravel and peaty" },
  { value: "235", text: "SILT/CLAY with " },
  { value: "302", text: "Clay/Silt" },
  { value: "303", text: "Sandy SILT" },
  { value: "304", text: "Gravelly SILT" },
  { value: "305", text: "Organic SILT" },
  { value: "306", text: "Peaty SILT" },
  { value: "307", text: "Gravelly SILT" },
  { value: "308", text: "Sandy gravelly SILT" },
  { value: "309", text: "SILT with Boulders" },
  { value: "310", text: "Sandy gravelly SILT" },
  { value: "313", text: "Sandy gravelly SILT with peat" },
  { value: "314", text: "Organic clayey sandy gravelly SILT with cobbles" },
  { value: "316", text: "Sandy SILT with cobbles" },
  { value: "317", text: "Sandy SILT with boulders" },
  { value: "318", text: "Organic Sandy SILT" },
  { value: "320", text: "Sandy gravelly SILT with cobbles" },
  { value: "321", text: "Organic sandy gravelly SILT with cobbles" },
  { value: "322", text: "Gravelly SILT with cobbles" },
  { value: "323", text: "Gravelly SILT with boulders" },
  { value: "324", text: "Organic Gravelly SILT" },
  { value: "325", text: "Organic Gravelly SILT with cobbles" },
  { value: "326", text: "SILT with cobbles" },
  { value: "327", text: "SILT with cobbles and boulders" },
  { value: "328", text: "Organic SILT with cobbles" },
  { value: "329", text: "SILT with cobbles" },
  { value: "330", text: "SILT with peaty" },
  { value: "331", text: "SILT with boulders" },
  { value: "332", text: "CLAY/SILT with peat" },
  { value: "333", text: "CLAY/SILT with gravel" },
  { value: "334", text: "Sandy gravelly CLAY/SILT" },
  { value: "335", text: "CLAY/SILT with boulders" },
  { value: "336", text: "Sandy gravelly CLAY/SILT" },
  { value: "337", text: "Sandy gravelly CLAY/SILT with peat" },
  { value: "338", text: "CLAY/SILT with cobbles" },
  { value: "339", text: "CLAY/SILT with peat" },
  { value: "401", text: "SAND" },
  { value: "402", text: "Clayey SAND" },
  { value: "403", text: "Silty SAND" },
  { value: "404", text: "Gravelly SAND" },
  { value: "405", text: "SAND with cobbles" },
  { value: "406", text: "SAND with boulders" },
  { value: "407", text: "Clayey silty SAND" },
  { value: "407", text: "Clayey sandy SILT" },
  { value: "408", text: "Clayey silty gravelly SAND" },
  { value: "409", text: "Clayey silty gravelly SAND with cobbles" },
  { value: "410", text: "Clayey gravelly SAND" },
  { value: "411", text: "Clayey gravelly SAND with cobbles" },
  { value: "412", text: "Silty gravelly SAND" },
  { value: "413", text: "Silty gravelly SAND with cobbles" },
  { value: "414", text: "Silty gravelly SAND with cobbles and boulders" },
  { value: "415", text: "Gravelly SAND with cobbles" },
  { value: "416", text: "Gravelly SAND with cobbles and boulders" },
  { value: "417", text: "Gravelly SAND with boulders" },
  { value: "418", text: "SAND with cobbles and  boulders" },
  { value: "430", text: "SAND and GRAVEL" },
  { value: "431", text: "Organic SAND" },
  { value: "432", text: "Clayey peaty SAND" },
  { value: "433", text: "Silty organic SAND" },
  { value: "434", text: "Gravelly organic SAND" },
  { value: "435", text: "Organic SAND with cobbles" },
  { value: "436", text: "Organic SAND with boulders" },
  { value: "437", text: "Clayey silty peaty SAND" },
  { value: "438", text: "Clayey silty gravelly peaty SAND" },
  { value: "501", text: "GRAVEL" },
  { value: "502", text: "Clayey GRAVEL" },
  { value: "503", text: "Silty GRAVEL" },
  { value: "504", text: "Sandy GRAVEL" },
  { value: "505", text: "Organic GRAVEL" },
  { value: "506", text: "GRAVEL with cobbles" },
  { value: "507", text: "GRAVEL with boulders" },
  { value: "508", text: "Clayey silty GRAVEL" },
  { value: "509", text: "Clayey sandy GRAVEL" },
  { value: "510", text: "Clayey GRAVEL with cobbles" },
  { value: "511", text: "Clayey GRAVEL with boulders" },
  { value: "512", text: "Clayey  organic GRAVEL" },
  { value: "513", text: "Clayey silty sandy GRAVEL" },
  { value: "514", text: "Clayey silty GRAVEL with cobbles" },
  { value: "515", text: "Clayey silty GRAVEL with boulders" },
  { value: "516", text: "Clayey silty GRAVEL with peat" },
  { value: "517", text: "Organic Clayey sandy GRAVEL" },
  { value: "518", text: "Clayey silty sandy GRAVEL with boulders" },
  { value: "519", text: "Clayey silty sandy GRAVEL with peat" },
  { value: "520", text: "Silty sandy GRAVEL" },
  { value: "521", text: "Silty GRAVEL with cobbles" },
  { value: "522", text: "Silty GRAVEL with boulders" },
  { value: "523", text: "Silty organic GRAVEL" },
  { value: "524", text: "Silty organic sandy GRAVEL" },
  { value: "525", text: "Sandy GRAVEL with cobbles" },
  { value: "526", text: "Sandy GRAVEL with boulders" },
  { value: "527", text: "Sandy organic GRAVEL" },
  { value: "528", text: "Silty sandy GRAVEL with cobbles" },
  { value: "601", text: "PEAT" },
  { value: "602", text: "Clayey PEAT" },
  { value: "603", text: "Silty PEAT" },
  { value: "604", text: "Sandy PEAT" },
  { value: "605", text: "Gravelly PEAT" },
  { value: "606", text: "PEAT with cobbles" },
  { value: "607", text: "Clayey silty PEAT" },
  { value: "608", text: "Clayey sandy PEAT" },
  { value: "609", text: "Clayey gravelly PEAT" },
  { value: "610", text: "Clayey silty sandy PEAT" },
  { value: "611", text: "Clayey silty sandy gravelly PEAT" },
  { value: "612", text: "Silty sandy PEAT" },
  { value: "613", text: "Silty sandy gravelly PEAT" },
  { value: "614", text: "Sandy gravelly PEAT" },
  { value: "701", text: "COBBLES" },
  { value: "702", text: "Clayey COBBLES" },
  { value: "703", text: "Silty COBBLES" },
  { value: "704", text: "Sandy COBBLES" },
  { value: "705", text: "Gravelly COBBLES" },
  { value: "706", text: "Organic COBBLES" },
  { value: "707", text: "Clayey silty COBBLES" },
  { value: "708", text: "Clayey sandy COBBLES" },
  { value: "709", text: "Clayey gravelly COBBLES" },
  { value: "710", text: "Clayey silty sandy COBBLES" },
  { value: "711", text: "Clayey silty gravelly COBBLES" },
  { value: "712", text: "Clayey silty gravelly sandy COBBLES" },
  { value: "713", text: "Silty sandy COBBLES" },
  { value: "714", text: "Silty gravelly COBBLES" },
  { value: "715", text: "Silty organic COBBLES" },
  { value: "716", text: "Silty gravelly sandy COBBLES" },
  { value: "717", text: "Silty sandy organic COBBLES" },
  { value: "718", text: "Silty sandy gravelly organic COBBLES" },
  { value: "719", text: "Sandy gravelly COBBLES" },
  { value: "720", text: "Sandy organic COBBLES" },
  { value: "721", text: "Gravelly organic COBBLES" },
  { value: "725", text: "COBBLES and BOULDERS" },
  { value: "730", text: "BOULDERS" },
  { value: "731", text: "Gravelly cobbles BOULDERS" },
  { value: "801", text: "MUDSTONE" },
  { value: "802", text: "SILTSTONE" },
  { value: "803", text: "SANDSTONE" },
  { value: "804", text: "LIMESTONE" },
  { value: "805", text: "CHALK" },
  { value: "806", text: "COAL" },
  { value: "807", text: "BRECCIA" },
  { value: "808", text: "CONGLOMERATE" },
  { value: "809", text: "Fine grained IGNEOUS" },
  { value: "810", text: "Medium grained IGNEOUS" },
  { value: "811", text: "Coarse grained IGNEOUS" },
  { value: "812", text: "Fine grained METAMORPHIC" },
  { value: "813", text: "Medium grained METAMORPHIC  (SCHIST)" },
  { value: "814", text: "Coarse grained METAMORPHIC  (SCHIST)" },
  { value: "815", text: "Pyroclastic (volcanic ash)" },
  { value: "816", text: "Gypsum, rocksalt" },
  { value: "817", text: "Shale" },
  { value: "988", text: "Bentonite or Grout" },
  { value: "999", text: "Void" },
  { value: "P101", text: "Plain Pipe" },
  { value: "P201", text: "Slotted Pipe" },
  { value: "P301", text: "Perforated Pipe" },
  { value: "P401", text: "Fine Mesh" },
  { value: "P402", text: "Medium Mesh" },
  { value: "P403", text: "Coarse Mesh" }
];

export interface LeftSideLayer {
  label: string;
  layerType: string;
  topStep: number;
  layerDepth: number;
  bottomStep: number;
  edgeType: string;
  layerDivider: string;
  horizontalMeasurement: string;
  verticalMeasurement: string;
}

export interface RightSideLayer {
  label: string;
  layerType: string;
  topStep: number;
  layerDepth: number;
  bottomStep: number;
  rootsObserved: string;
  rootsMaxDiameter: number;
  edgeType: string;
  layerDivider: string;
  horizontalMeasurement: string;
  verticalMeasurement: string;
}
